export const isCMSPreviewMode = () => {
    const siteConfig = window.topContext.config.getSiteConfig();
    return siteConfig.preview;
};
